module.exports = __webpack_public_path__ + "media/customizations/fieldslife/logo-a7a14a159dfddd2682923ef1ac5ff96c.png";